import './App.css';

import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

import AboutUsPage from './pages/AboutUsPage';
import Homepage from './pages/HomePage/homepage';
import estatedevelopment from './pages/Realestate_development/investment';
import Project_Boite311 from './pages/Project_Boite311/Project_Boite311';
import valleycourt from './pages/Valley_Court/valleycourt';
import Construction from './pages/Construction/Construction';
import Investment from './pages/Investment/Investment';
import Remodelling from './pages/Remodelling/Remodelling';
import Infrastructure from './pages/Infrastructure/Infrastructure';
import Portfolio from './pages/Portfolio/Portfolio';
import Contact from './pages/Contact/Contact'
import Projects from './pages/Projects/Projects'
import boiteAzure from './pages/Boite Azure/boiteAzure'
import BoiteSapphire from './pages/Boite Sapphire/boiteSapphire'
import Valley_Court2 from './pages/ValleyCourt2/valleycourt2'
import Team from './pages/TheTeam/Team'
import teamMember1 from './pages/TheTeam/First_Pane/teamMember1';
import teamMember2 from './pages/TheTeam/First_Pane/teamMember2';
import teamMember3 from './pages/TheTeam/First_Pane/teamMember3';
import teamMember4 from './pages/TheTeam/First_Pane/teamMember4';
import realEstatePort from './pages/Portfolio/Blocks/real-estate-portfolio'

import constructionPort from './pages/Portfolio/Blocks/constructionPort'
import portRemodelling from './pages/Portfolio/Blocks/port-remodelling'


import Home2 from './pages/Home2/Home2';

import Biote_888 from './pages/Biote 888 Residence/Biote_888';
import Biote_lapis from './pages/Biote_Lapis/Biote_lapis';
import Biote_cobalt from './pages/Biote Cobalt/Biote_cobalt';
import Biote_cyan from './pages/Biote CYAN/Biote_cyan';
import Acci_Ultra from './pages/Acci Ultra Modern/Acci_ultra'
import Biote_lapis_II from './pages/Biote_Lapis_II Residence/Biote_lapis_II';

import Biote_aqua from './pages/Biote_Aqua Residence/Blocks/Biote_aqua';
import Biote_capri from './pages/Biote Capri/Blocks/Biote_capri';

import Biote_Cobalt2 from './pages/Biote_Cobalt2/Blocks/Biote_Cobalt'

import ContactUs from './Components/Contact/Contact'
import Video_gallery from './pages/Videos/Video_gallery';


import "react-toastify/dist/ReactToastify.css";




function App() {
  return (
    <div className="App">
        <Router >
          
          <Switch>
    
          <Route exact path="/home2" component={Homepage} />
          
          <Route exact path="/" component={Home2} />
          
          <Route  exact path="/teamMember4" component={teamMember4} />

            <Route  exact path="/About" component={AboutUsPage} />
            
            <Route  exact path="/estatedevelopment" component={estatedevelopment} />
            
            <Route  exact path="/boite311" component={Project_Boite311} />
            
            <Route  exact path="/valley_court" component={valleycourt} />
            
            <Route  exact path="/Construction" component={Construction} />
            
            <Route  exact path="/investment" component={Investment} />
            <Route  exact path="/remodelling" component={Remodelling} />
            
            <Route  exact path="/infrastructure" component={Infrastructure} />
            
            <Route  exact path="/Portfolio" component={Portfolio} />
            
            <Route  exact path="/Contact" component={Contact} />
            
            <Route  exact path="/Projects" component={Projects} />
            
            <Route  exact path="/boiteAzure" component={boiteAzure} />
            
            
            <Route  exact path="/BoiteSapphire" component={BoiteSapphire} />
            
            
            <Route  exact path="/Valley_Court2" component={Valley_Court2} />
            
            <Route  exact path="/team" component={Team} />
            
            <Route  exact path="/teamMember1" component={teamMember1} />
            
            <Route  exact path="/teamMember2" component={teamMember2} />
            
            <Route  exact path="/teamMember3" component={teamMember3} />
            
            <Route  exact path="/teamMember4" component={teamMember4} />
            
            <Route  exact path="/port-real-estate" component={realEstatePort} />
            
            <Route  exact path="/port-construction" component={constructionPort} />
            
            <Route  exact path="/port-remodelling" component={portRemodelling} />
            
           

            
            <Route  exact path="/biote_888" component={Biote_888} />

            
            <Route  exact path="/biote_lapis" component={Biote_lapis} />

            
            <Route  exact path="/biote_cobalt" component={Biote_cobalt} />
         
            <Route  exact path="/biote_cyan" component={Biote_cyan} />

            <Route  exact path="/acci_Ultra" component={Acci_Ultra} />
            
            <Route  exact path="/biote_lapis_II" component={Biote_lapis_II} />

            
            <Route  exact path="/biote_aqua" component={Biote_aqua} />
            
            <Route  exact path="/biote_capri" component={Biote_capri} />
            
            <Route  exact path="/biote_Cobalt2" component={Biote_Cobalt2} />

            
            <Route  exact path="/contactus" component={ContactUs} />
            
            <Route  exact path="/video_gallery" component={Video_gallery} />




            
            


            

            

            

            
            

            


           

            

            
            
            
            

            
            
            

           

          </Switch>
        </Router>
    </div>
  );
}

export default App;


